import { useMemo } from 'react'

import { SubnetType } from '@infura/key-service-sdk/lib/v1/proto/service_plan/v1/networks'
import { V1Network } from '@infura/packages.uks'

import useUser from 'hooks/useUser'

import { useUks } from 'lib/api/uks'
import { AllNetworks, sortNetworksByPriority } from 'lib/utils/keys'

export const useUksNetworks = apiKeySelected => {
  const { user } = useUser()

  const {
    data: networksData,
    error: networksDataError,
    isLoading: isLoadingNetworksData,
    mutate: networksDataMutate
    // @ts-expect-error enabled to support strictNullChecks - Please fix this if you can!
  } = useUks(['networkMethodsList', user?.id], {
    revalidateOnFocus: false,
    shouldRetryOnError: true
  })

  const networks = networksData?.result || {}

  const {
    data: project,
    isLoading: projectIsLoadin,
    mutate: projectMutate
  } = useUks(['projectMethodsGet', apiKeySelected], {
    revalidateOnFocus: false,
    shouldRetryOnError: true
  })

  const revalidate = async () => {
    await networksDataMutate()
    await projectMutate()
  }

  const sortedEntries: Array<[string, V1Network]> = useMemo(() => {
    const networkKeys = Object.keys(networks)
    return sortNetworksByPriority(networkKeys as Array<AllNetworks>).map(networkKey => [
      networkKey,
      networks[networkKey]
    ])
  }, [networks])

  const allNetworkEntries: Array<[string, V1Network]> = useMemo(() => {
    return sortedEntries.filter(([networkName, network]: [string, V1Network]) => {
      return !network.disabled && networkName !== 'ipfs' && networkName !== 'gas' && networkName !== 'starknet'
    })
  }, [sortedEntries])

  const activeNetworkEntries: Array<[string, V1Network]> = useMemo(() => {
    const networksFiltered = allNetworkEntries.filter(([networkName, network]: [string, V1Network]) => {
      // @ts-expect-error enabled to support strictNullChecks - Please fix this if you can!
      const entitlementsArray = project?.result?.networks[networkName]?.subnets
      return entitlementsArray
        ? // @ts-expect-error enabled to support strictNullChecks - Please fix this if you can!
          Object.keys(network.subnets).some(subnet => entitlementsArray.includes(SubnetType[subnet]))
        : false
    })

    return networksFiltered.map(([networkName, networkData]) => [
      networkName,
      {
        ...networkData,
        // @ts-expect-error enabled to support strictNullChecks - Please fix this if you can!
        subnets: Object.entries(networkData.subnets)
          .filter(
            ([subnetName, subnetValue]) =>
              // @ts-expect-error enabled to support strictNullChecks - Please fix this if you can!
              !subnetValue.disabled && project?.result?.networks[networkName]?.subnets?.includes(SubnetType[subnetName])
          )
          .reduce(
            (acc, [subnetName, subnetValue]) => ({
              ...acc,
              [subnetName]: subnetValue
            }),
            {}
          )
      }
    ])
  }, [allNetworkEntries, project])

  return {
    activeNetworkEntries,
    allNetworkEntries,
    error: networksDataError,
    isLoading: isLoadingNetworksData || projectIsLoadin,
    revalidate
  }
}
